import { Portal as ChakraPortal } from '@chakra-ui/react-v2';
import type { PortalProps as ChakraPortalProps } from '@chakra-ui/react-v2';
import { useContext } from 'react';

import { OverlayContainerRefContext } from '@frontend/legacy-components';

export interface PortalProps extends ChakraPortalProps {
  overrideOverlayContainer?: boolean;
}

export const Portal = (originalProps: PortalProps) => {
  const overlayContext = useContext(OverlayContainerRefContext);

  const {
    containerRef: originalContainerRef,
    overrideOverlayContainer = false,
    ...restProps
  } = originalProps;

  // Determine containerRef based on conditions
  const containerRef =
    originalContainerRef ||
    (!overrideOverlayContainer ? overlayContext?.containerRef : undefined);

  const props: ChakraPortalProps = {
    ...restProps,
    ...(containerRef && { containerRef }),
  };

  return <ChakraPortal {...props} />;
};
